<template>
  <w-setting-sliding-popup ref="slidingPopup"  title="서비스 포트 추가" width="400px" @close="close">
    <div slot="content">
      <el-form ref="servicePortForm" :rules="rules" :model="portFormData" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="netPortnum" label="포트">
              <el-input-number placeholder="0 ~ 65535"  controls-position="right" v-model="portFormData.netPortnum" :min="0" :max="65535" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="netProtocol" label="프로토콜">
              <el-select v-model="portFormData.netProtocol">
                <el-option label="TCP" value="TCP"></el-option>
                <el-option label="UDP" value="UDP"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item prop="serviceName" label="서비스명">
            <el-input clearable v-model="portFormData.serviceName"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="clickSaveButton" >저장</el-button>
      <el-button size="large" @click="clickClose">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { isEmpty } from '@/utils/basic';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';

export default {
  name: 'WAddServicePortSlidingPopup',
  data() {
    return {
      portFormData: {
        netPortnum: null,
        netProtocol: 'TCP',
        serviceName: null,
      },
      rules: {
        netPortnum: [{ required: true, trigger: 'blur', validator: this.validateServicePort }],
        netProtocol: [{ required: true, trigger: 'blur', validator: this.validateProtocol }],
      },
      targetServicePort: 'TCP',
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
      this.portFormData = {
        netPortnum: null,
        netProtocol: 'TCP',
        serviceName: null,
      };
    },
    close() {
      this.portFormData = {
        netPortnum: null,
        netProtocol: null,
        serviceName: null,
      };
    },
    clickClose() {
      this.$refs.slidingPopup.close();
    },
    // 저장 이벤트
    clickSaveButton() {
      this.$refs.servicePortForm.validate().then((validateResult) => {
        if (validateResult) {
          // 인스턴스 변수 플래그를 이용하여 중복성 체크
          const params = this.portFormData;
          // api 요청
          OperationSettingsAPI.addNetPortSvcName(params).then((response) => {
            if (response.data.success) {
              this.$emit('load-data');
              this.clickClose();
            }
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '포트', response.data.success));
          });
        }
      });
    },
    /**
     * 포트, 프로토콜의 중복 체크
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     * @author jda
     */
    validateServicePort(rule, value, callback) {
      const portData = this.portFormData;
      if (isEmpty(value)) {
        callback(new Error('값을 입력해주세요'));
      } else {
        OperationSettingsAPI.isExistPort(portData).then((response) => {
          const inexistent = response.data.data;
          if (response.data.success && inexistent) {
            callback();
          } else {
            callback(new Error(`이미 존재하는 ${portData.netProtocol}포트입니다.`));
          }
        });
      }
    },
    /**
     * 프로토콜 중복 체크 -> 포트 컴포넌트 아래에 error메시지 표현
     * @return {[type]} [description]
     * @author jda
     */
    validateProtocol(rule, value, callback) {
      this.$refs.servicePortForm.validateField('netPortnum');
      callback();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/DomainServicePort/popup/AddServicePortSlidingPopup.vue